import styled, { CSSObject } from 'styled-components';
import css from '@styled-system/css';
import { CSSProperties } from 'react';
import Box from '@spotnana/pixel-react/dist/Box';
import { Typography } from '@spotnana/blocks/src/Typography';

const SectionHeaderIcon = styled.div(
  css({
    width: '40px',
    height: '40px',
    border: 'thinSolid',
    borderColor: 'bg.lightBlueGrey',
    borderRadius: 'md',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mr: '40px',
  }) as unknown as CSSObject,
);

interface SectionProps {
  icon: JSX.Element;
  heading: string;
  dataTestId?: string;
  styles?: CSSObject;
  iconStyles?: CSSProperties;
  containerStyles?: CSSObject;
}

const Section = ({ icon, heading, dataTestId, styles, iconStyles, containerStyles }: SectionProps): JSX.Element => (
  <Box display="flex" alignItems="center" mt={4} data-testid={dataTestId} style={containerStyles}>
    <SectionHeaderIcon data-testid={dataTestId && `${dataTestId}-icon`} style={iconStyles}>
      {icon}
    </SectionHeaderIcon>
    <Box>
      <Typography variant="header3" data-testid={dataTestId && `${dataTestId}-heading-text`}>
        {heading}
      </Typography>
    </Box>
  </Box>
);

export default Section;
